import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          {/* Image Container */}
          <div className="mb-12 rounded-3xl overflow-hidden mx-auto max-w-4xl">
            <img
              src="https://storage.readdy-site.link/project_files/0adf07f6-cfdf-46bd-828d-bf79dff9dec4/04a9c4ec-93e8-4764-9ebc-27c76b6bbede_SIGNS-1.svg?v=b0b17f32ea0dcc4cdad5ede5bac64d7d"
              alt="Let's Work Together"
              className="w-full h-auto object-contain"
            />
          </div>

          {/* Headline */}
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Ready to <span className="italic text-[#06B6D4]">elevate</span> your brand and{' '}
            <strong>drive real results?</strong>
          </h2>

          {/* Subtext */}
          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
            Let's create something extraordinary together. Your vision, our expertise.
          </p>

          {/* CTA Button */}
          <Link
            to="/contact"
            className="inline-flex items-center justify-center bg-gray-900 text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-gray-800 transition-all duration-200 hover:shadow-2xl whitespace-nowrap group"
          >
            Start Your Project Today
            <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
          </Link>

          {/* Micro Text */}
          <p className="text-sm text-gray-500 mt-6">
            Free consultation • No obligation • Quick response
          </p>
        </div>
      </div>
    </section>
  );
}